module.exports = __webpack_public_path__ + "fc5e4257bf19c340e94daabdc0dca03c.svg";